'use client';
import React, { useEffect, useState } from 'react';
import styles from './scss/aipilot.module.scss';
import ContentLayout from '../../layout/contentLayout';
import WorktualTab from '../../components/custom_components/worktualTab';
import ClvAnalysis from './clvAnalysis';
import Segmentation from './segmentation';
import BuyerPersona from './buyerPersona';
import ChurnPrediction from './churnPrediction';
import Recommendations from './recommendations';
import AiPilot from '../aiPilot';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OrchestrationTs from './orchestrationts';
import Orchestrate2 from './orchestrate2';
import Orchestrate4 from './orchestrate4';

const AiPilotAnimation = () => {
  const [activeTab, setActiveTab] = useState(0);
  const {animation} = useSelector((store: any) => store.dashboardReducer)
console.log('animation-',animation)
const navigate = useNavigate();
  
  // ✅ Define tabs first
  const tabs = [
    { label: 'CLV Analysis Agent', content: <ClvAnalysis onComplete={() => handleNextTab()} /> },
    { label: 'Segmentation Agent', content: <Segmentation onComplete={() => handleNextTab()} /> },
    { label: 'Buyer Persona Agent', content: <BuyerPersona onComplete={() => handleNextTab()} /> },
    { label: 'Churn Prediction Agent', content: <ChurnPrediction onComplete={() => handleNextTab()} /> },
    { label: 'Orchestration Agent', content: <OrchestrationTs onComplete={() => handleNextTab()} /> },
  ];

  // ✅ Now safe to use tabs.length here
  const handleNextTab = () => {
    setActiveTab(prev => (prev < tabs.length - 1 ? prev + 1 : prev));
  };
    
    useEffect(() => {
      if (animation === true) { 
        navigate('/aiPilot');
      }
    }, [animation, navigate]);
    
  return (
    // <ContentLayout noPadding={true}>
    //   <div className={`${styles.aipilotsec} animatetabs`}>
    //     <div className={styles.toptitle}>
    //       <div className={styles.aipheader}>AI Pilot</div>
    //       <div className={styles.aipdesc}>Turns raw data into data-driven actions.</div>
    //     </div>
    //     <WorktualTab
    //       tabs={tabs}
    //       activeTab={activeTab}
    //       onTabChange={setActiveTab}
    //     />
    //   </div>
    // </ContentLayout>

<ContentLayout noPadding={true}>
<div className={styles.titlearea}>
  <div className={styles.titlename}>AI Pilot</div>
  <div className={styles.titledesc}>Turns raw data into data-driven actions.</div>
</div>
<WorktualTab tabs={tabs} 
          activeTab={activeTab}
          onTabChange={setActiveTab} className="aicustomTab" />
</ContentLayout>



  );
};

export default AiPilotAnimation;
